import React from 'react';
import { Box, SimpleGrid } from '@chakra-ui/react';
import Card from 'components/Cards/Card';
import CustomTable from 'components/Table/CustomTable';
import { useGetBulkInvitedRealtorsQuery , useResendBulkInviteMutation } from 'reducers/realtor.service';
import { InvitedRealtorHeader } from 'components/Table/Headers/Users/realtorinvitations';
import { LENDER_TYPE } from 'constants/index';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
export default function Lenders() {
    const { data: lenderInvitations, isError: LenderListisError , refetch , isLoading: loadingLenderList } = useGetBulkInvitedRealtorsQuery(LENDER_TYPE);
    const [handleResendInvite] = useResendBulkInviteMutation();
    const history = useHistory();
    let handleBulkInviteResend = (args, USERTYPE)=>{
        handleResendInvite({ invitationId: args._id , USERTYPE }).unwrap().then(()=>{
            refetch();
        });
    };
    let handleBulkInviteDetails = (args, USERTYPE)=>{
        let prefix = USERTYPE === LENDER_TYPE ? '/lenders' : '/realtors';
        let url = `/organization/invitations${prefix}/` + args._id;
        history.push(url);
    };
    let invitedLenderHeader = InvitedRealtorHeader({
        tableActions: {
            data: {
                USERTYPE: LENDER_TYPE,
                handleResendInvite: handleBulkInviteResend,
                handleBulkInviteDetails
            }
        }
    });

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <SimpleGrid
                mb="20px"
                columns={{ sm: 1, md: 1 }}
                spacing={{ base: '20px', xl: '20px' }}
            >

                <Card>
                    <p className='bold-text'>Invited Lenders</p>
                    <CustomTable
                        data={lenderInvitations}
                        handleRefresh={refetch}
                        columns={invitedLenderHeader}
                        isLoading={loadingLenderList}
                        isError={LenderListisError}
                    />
                </Card>

            </SimpleGrid>
        </Box>
    );
}
